<template>
  <van-popup v-model="visible" :close-on-click-overlay="false" round>
    <div class="app-tip">
      <div class="app-tip__title">{{ $t('提示') }}</div>
      <div class="app-tip__content">
        <slot />
      </div>
      <div class="app-tip__btn-group">
        <button class="btn-item close" @click="visible = false">{{ $t('取消') }}</button>
        <button class="btn-item" @click="$emit('confirm')">{{ $t('确定') }}</button>
      </div>
    </div>
  </van-popup>
</template>

<script>

export default {
  name: 'AppTip',
  data() {
    return {
      visible: false
    }
  },
  methods: {
    init() {
      this.visible = true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variables.scss';

.app-tip {
  padding: 0.3rem;
  width: 6rem;

  &__title {
    margin-top: 0.1rem;
    text-align: center;
    line-height: 0.4rem;
    font-size: 0.36rem;
    font-weight: 700;
  }
  &__content {
    margin-top: 0.3rem;
    padding: 0 0.2rem;
    line-height: .34rem;
    font-size: 0.28rem;
    color: $info;
  }
  &__btn-group {
    margin-top: 0.3rem;
    text-align: center;

    .btn-item {
      width: 2.3rem;
      padding: 0.2rem 0;
      background-color: $theme;
      color: #fff;
      border-radius: 1rem;
      font-size: 0.3rem;
      text-align: center;
      line-height: 0.4rem;
    }
    .close {
      margin-right: 0.2rem;
      background-color: $disabled;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppTmpl/AppTip.vue